import { Injectable } from '@angular/core';

// RxJs
import { Observable } from 'rxjs';

// GraphQL
import { Apollo, gql } from 'apollo-angular';
import { take } from 'rxjs/operators';



@Injectable({
  providedIn: 'root'
})
export class GraphQLService {

  constructor(
    private readonly apollo: Apollo
  ) { }


  public mutation(link: string, variables: any = { }): Observable<any> {
    return this.apollo.mutate({ mutation: gql(link), variables }).pipe(take(1));
  }


  public query(link: string, variables: any = { }, cache: boolean = false) {
    return this.apollo.query({ query: gql(link), variables, fetchPolicy: cache ? 'cache-first' : 'network-only' }).pipe(take(1));
  }
}
